import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {FaHome} from 'react-icons/fa';
import {useNavigate, useLocation} from 'react-router-dom';
import Get from '../components/Get'; // keep your service file
import Post from '../components/Post'; // keep your service file
import Header from '../components/Header'; // keep your Header component

const option = {
  title: 'Loading',
  message: 'Please Wait...',
  isCancelable: true,
};

const PostFree = () => {
  const [setting, setSetting] = useState(null);
  const [amount, setAmount] = useState('');
  const [mobile, setMobile] = useState('');
  const [name, setName] = useState('');
  const [account, setAccount] = useState('');
  const [ifsc, setIfsc] = useState('');
  const [methodId, setMethodId] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const params = location.state || {};

  useEffect(() => {
    setMethodId(params.method_id || '');
    const settingData = localStorage.getItem('setting');
    if (settingData) {
      setSetting(JSON.parse(settingData).withdraw);
    }
  }, [params.method_id]);

  const submit = () => {
    if (!amount) {
      alert('Amount is required');
      return;
    }
    if (!methodId) {
      alert('Please choose a method');
      return;
    }
    if (parseFloat(amount) < parseFloat(setting.min_amount)) {
      alert('Please Enter Min Amount ' + setting.min_amount);
      return;
    }
    if (methodId !== '1') {
      if (!mobile) {
        alert('Please enter paytm mobile number');
        return;
      }
      post();
    } else {
      if (!name) {
        alert('Please enter account holder name');
        return;
      }
      if (!account) {
        alert('Please enter account number');
        return;
      }
      if (!ifsc) {
        alert('Please enter IFSC number');
        return;
      }
      post();
    }
  };

  const post = () => {
    setLoading(true);
    Post.Withdraw({amount, method_id: methodId, mobile, name, account, ifsc})
      .then(res => {
        setLoading(false);
        if (res.success) {
          setAmount('');
          setMobile('');
          setName('');
          setAccount('');
          setIfsc('');
          alert('Success: ' + res.success);
        } else if (res.errorMsg) {
          alert('Error: ' + res.errorMsg);
        }
      })
      .catch(error => {
        setLoading(false);
        console.error('Post error', error);
      });
  };

  return (
    <Container>
      <Header />
      <Content>
        {/* <StatusBar /> */}
        {setting && setting.text && <Warning>{setting.text}</Warning>}

        <Card>
          <Label>Amount</Label>
          <Input
            type="number"
            value={amount}
            onChange={e => setAmount(e.target.value)}
            placeholder="Enter amount"
          />

          {methodId !== '1' ? (
            <>
              <Label>Mobile No.</Label>
              <Input
                type="number"
                value={mobile}
                onChange={e => setMobile(e.target.value)}
                placeholder="Enter mobile number"
              />
            </>
          ) : (
            <>
              <Label>Holder Name</Label>
              <Input
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="Enter account holder name"
              />

              <Label>Account No.</Label>
              <Input
                type="number"
                value={account}
                onChange={e => setAccount(e.target.value)}
                placeholder="Enter account number"
              />

              <Label>IFSC Code</Label>
              <Input
                value={ifsc}
                onChange={e => setIfsc(e.target.value)}
                placeholder="Enter IFSC code"
              />
            </>
          )}

          <SubmitBtn onClick={submit} disabled={loading}>
            {loading ? 'Processing...' : 'Withdraw Now'}
          </SubmitBtn>
        </Card>
      </Content>
    </Container>
  );
};

export default PostFree;

// Styled Components
const Container = styled.div`
  background-color: #f9f9f9;
  min-height: 100vh;
`;

const Content = styled.div`
  padding-bottom: 20px;
`;

const StatusBar = styled.div`
  background-color: #00318b;
  height: 20px;
`;

const Warning = styled.div`
  color: red;
  font-size: 14px;
  text-align: center;
  margin-top: 20px;
`;

const Card = styled.div`
  background-color: white;
  margin: 30px 20px;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Label = styled.label`
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
  margin-top: 20px;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  background-color: #fafafa;
  margin-bottom: 15px;
`;

const SubmitBtn = styled.button`
  background-color: #00318b;
  color: white;
  padding: 14px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  width: 100%;
  cursor: pointer;
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
